export const THROTTLE_OPTIONS = {leading: true, trailing: false};
export const THROTTLE_MAX_WAIT = 5000;
